import { Stack } from '@mui/material'
import SettingsComp from '../components/Settings/SettingsComp'
import Header from '../components/Header/Header'

export default function Settings() {
  return (
    <>
      <Header />
      <Stack direction='column' padding={'100px'} alignItems='flex-start' justifyContent='flex-start'>
        <SettingsComp />
      </Stack>
    </>
  )
}
